import { Link as RouterLink } from "react-router-dom";
import { Box, Image, Text, useColorModeValue } from "@chakra-ui/react";


const Logo = () => {
  const footPrintImg = `/images/footprint${useColorModeValue("", "-dark")}.png`;

  return (
    <RouterLink to="https://abhudaym.vercel.app/">
      <Box
        display="inline-flex"
        alignItems="center"
        height="40px"
        _hover={{
          "& img": {
            transform: "rotate(20deg)",
            transition: "transform 0.2s ease-in-out"
          }
        }}
      >
        <Image
          src={footPrintImg}
          width="20px"
          height="20px"
          alt="Logo"
        />
        <Text
          color={useColorModeValue("gray.800", "whiteAlpha.900")}
          fontFamily="M PLUS 1c"
          fontWeight="bold"
          ml={1}
          fontSize="lg"
        >
          Abhuday Mishra
        </Text>
      </Box>
    </RouterLink>
  );
};

export default Logo;